export default __webpack_public_path__ + "static/media/Chestguard of the Black Dragon.c93acd37.jpg";